var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GrPagination,{attrs:{"default-page":_setup.pagination.currentPage,"items-per-page":_setup.pagination.perPage,"items-per-page-visible":_setup.pagination.perPageVisible,"total":_setup.pagination.total},on:{"updateItemsPerPage":_setup.changeItemsPerPage,"updateCurrentPage":_setup.changeCurrentPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }